import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'

export function useRealtimeCharacter(characterId: string | undefined) {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!characterId) return

    const channel = supabase
      .channel(`character-${characterId}`)
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'character_snapshots',
          filter: `character_id=eq.${characterId}`,
        },
        () => {
          queryClient.invalidateQueries({ queryKey: ['character', characterId] })
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'character_injuries',
          filter: `character_id=eq.${characterId}`,
        },
        () => {
          queryClient.invalidateQueries({ queryKey: ['character', characterId] })
        }
      )
      .on(
        'postgres_changes',
        {
          event: '*',
          schema: 'public',
          table: 'character_skills',
          filter: `character_id=eq.${characterId}`,
        },
        () => {
          queryClient.invalidateQueries({ queryKey: ['character', characterId] })
        }
      )
      .subscribe()

    return () => {
      supabase.removeChannel(channel)
    }
  }, [characterId, queryClient])
}
